import { dateOnlyInTz, dayBoundsInTz } from '@statura/utils';

/** A care-date key must be interpreted in the same named clock as its MAR view. */
export function marReadWindow(localDate: string, careTimezone: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(localDate)) throw new Error('Invalid MAR care date');
  const ordinal = new Date(`${localDate}T00:00:00Z`);
  if (!Number.isFinite(ordinal.getTime()) || dateOnlyInTz(ordinal, 'UTC') !== localDate)
    throw new Error('Invalid MAR care date');
  if (!careTimezone?.trim()) throw new Error('MAR care timezone is required');
  if (/^[+-]/.test(careTimezone)) throw new Error('MAR requires a named care timezone');
  // Validate without substituting a tenant, host or default clock.
  new Intl.DateTimeFormat('en', { timeZone: careTimezone }).format(ordinal);
  ordinal.setUTCDate(ordinal.getUTCDate() + 1);
  return {
    startUtc: dayBoundsInTz(localDate, careTimezone).startUtc,
    endUtcExclusive: dayBoundsInTz(dateOnlyInTz(ordinal, 'UTC'), careTimezone).startUtc,
  };
}
